module.exports = __webpack_public_path__ + "static/mobile-ticket-for-school-transport-552393482148dda17df7f68e98b4b035.jpg";